import React, { memo } from "react";
import { validators } from "investira.sdk";

import {
  Stack,
  Typography,
  Card,
  Tooltip,
  Icon,
} from "investira.react.components";
import { formats } from "investira.sdk";

// < 0 → o ativo rende menos que o título livre de risco.
// 0 a 1 → desempenho baixo, mas positivo.
// 1 a 2 → razoável, considerado aceitável.
// > 2 → muito bom, indica forte retorno em relação ao risco.

const SharpeCard = memo((props) => {
  const { value = 0, label = "Sharpe", tooltip } = props;

  const palette = (pValue) => {
    // Função que retorna a cor de acordo com o valor do Sharpe
    if (pValue < 0) {
      return {
        backgroundColor: "error.main",
        color: "error.contrastText", // Cor de contraste para texto em fundo escuro
      };
    } else if (pValue >= 0 && pValue < 1) {
      return {
        backgroundColor: "warning.main",
        color: "background.dark",
      };
    } else if (pValue >= 1 && pValue < 2) {
      return {
        backgroundColor: "info.highlight",
        color: "info.contrastText",
      };
    } else if (pValue >= 2) {
      return {
        backgroundColor: "primary.main",
        color: "primary.contrastText",
      };
    }
    // Valor padrão caso não se encaixe em nenhum critério
    return {
      color: "text.primary",
    };
  };

  // Função que retorna uma frase curta e humanizada de acordo com o valor do Sharpe
  const sharpeDescricao = (pValue) => {
    if (validators.isNull(pValue)) return "Sem informação";
    if (pValue < 0) return "Abaixo do risco livre";
    if (pValue >= 0 && pValue < 1) return "Baixo retorno";
    if (pValue >= 1 && pValue < 2) return "Retorno aceitável";
    if (pValue >= 2) return "Ótimo retorno";
    return "Sem classificação";
  };

  return (
    <Card
      sx={{
        flex: 1,
        display: "flex",
        minHeight: 0,
        ...palette(value),
      }}
    >
      <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
        <Stack direction="row" justifyContent="space-between">
          <Typography
            variant="caption"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            {label}
          </Typography>
          {tooltip && (
            <Tooltip title={tooltip}>
              <span>
                <Icon size={16} color={"inherit"} iconName="information" />
              </span>
            </Tooltip>
          )}
        </Stack>
        <Stack direction="column" justifyContent="flex-end">
          <Stack>
            <Typography variant={{ xs: "h6", xl: "h5" }} color="inherit">
              <b>
                {!validators.isNull(value)
                  ? formats.formatNumber(value, 3, true)
                  : `---`}
              </b>
            </Typography>
          </Stack>
          <Stack>
            <Typography
              variant={"caption"}
              color="inherit"
              sx={{ fontWeight: 500 }}
            >
              {sharpeDescricao(value)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
});

export default SharpeCard;
